export default __webpack_public_path__ + "static/media/330_store05-fr-web.988da81d.png";